import React from "react";
import { Form, Select } from "semantic-ui-react";
import { Controller } from "react-hook-form";
import stateOptions from "../constants/USStates";

export const AddressFormField = ({ register, control, prefix }: any) => {
  return (
    <>
      <Form.Field width={16}>
        <input
          placeholder='Street'
          name='street'
          ref={register}
          id={`${prefix}-address`}
          data-testid={`${prefix}-street`}
        />
      </Form.Field>
      <Form.Group>
        <Form.Field width={7}>
          <input placeholder='City' name='city' ref={register} data-testid={`${prefix}-city`} />
        </Form.Field>
        <Form.Field width={5}>
          <Controller
            name='state'
            control={control}
            render={({ onChange, value }) => (
              <Select
                fluid
                placeholder='State'
                search
                style={{ width: "100%" }}
                data-testid={`${prefix}-state`}
                name='state'
                options={stateOptions}
                onChange={(e, { value }) => onChange(value)}
                value={value}
              />
            )}
          />
        </Form.Field>
        <Form.Field width={4}>
          <input placeholder='ZIP' name='zip' ref={register} data-testid={`${prefix}-zip`} />
        </Form.Field>
      </Form.Group>
    </>
  );
};

export default AddressFormField;
